import { WidgetProps } from "@rjsf/core";

export const StatementWidget = (props: WidgetProps) => (
    <span dangerouslySetInnerHTML={{ __html: props.label }} className={props.className} />
);
